<template>
  <div class="question-detail">
    <div class="header">
      <div class="back">
        <!-- <span class="icon"></span> -->
        <span class="text">題目詳情</span>
      </div>

      <div class="func"> 
        <div class="edit-btn" @click="edit(form.id)">編輯題目</div>
        <div class="edit-btn" @click="preview">預覽</div>
      </div>
    </div>
    <div class="container">
      <vue-dividing-line class="line" title="基本設定"></vue-dividing-line>
      <div class="single">
        <span>題目編號:</span>
        <span>{{ form.question_no }}</span>
      </div>
      <div class="single">
        <span>課程版本:</span>
        <span>{{ form.lang }}</span>
      </div>
      <div class="single">
        <span>題目類型:</span>
        <span>{{ form.type_convert }}</span>
      </div>

      <vue-dividing-line class="line" title="問題內容"></vue-dividing-line>
      <div class="question-cte">
        <component :is="echo" v-if="form.id" :form="form"></component>
      </div>

      <vue-dividing-line class="line" title="解答思路" v-if="form.explanation"></vue-dividing-line>
      <div class="explanation" v-if="form.explanation">
         <vue-mathjax :formula="form.explanation" :safe="false"/>
      </div>

      <vue-dividing-line class="line" title="題目所在練習"></vue-dividing-line>
      <div class="practice-list">
        <div class="practice-single th">
          <span>練習編號</span>
          <span>課程版本</span>
        </div>
        <div class="practice-single" v-for="(its, idx) in questionList" :key="idx">
          <span class="id" @click="practiceDetail(its.id)">{{ its.number }}</span>
          <span>{{ its.lang }}</span>
        </div>
        <div class="empty-data" v-if="questionList.length == 0">No Data</div>
      </div>
    </div>

    <DialogPreview v-if="previewSwitch" :form="form" @close="previewSwitch = false"></DialogPreview>
  </div>
</template>

<script>
import ChoiceEcho from './echo_components/choice/choice_echo.vue';
import DetermineEcho from './echo_components/determine/determine_echo.vue';
import FillMatrix from './echo_components/fillingBlanks/matrim_fill.vue';
import FillingBlanksEcho from './echo_components/fillingBlanks/fillingBlanks_echo.vue';
import SumEcho from './echo_components/sum/sum_echo.vue'
import ImgDragEcho from './echo_components/imgDrag/imgDrag_echo.vue'
import TextDragEcho from './echo_components/textDrag/textDrag_echo.vue'
import TextDragEcho2 from './echo_components/textDrag/textDrag_echo_2.vue'
import LigatureEcho from './echo_components/ligature/ligature_echo.vue'
import HotspotEcho from './echo_components/hotspot/hotspot_echo.vue'
import DialogPreview from './dialog'
import { toSnakeCase } from '@/utils/data-format'
import { getQuestionDetail } from "@/api/question";
import { getPractises } from '@/api/practises'

export default {
  components: {
    ChoiceEcho,
    DetermineEcho,
    FillingBlanksEcho,
    FillMatrix,
    SumEcho,
    ImgDragEcho,
    TextDragEcho,
    TextDragEcho2,
    LigatureEcho,
    HotspotEcho,
    DialogPreview
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    language: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      echo: 'ChoiceEcho',
      convertType: [
        'ChoiceEcho',
        'DetermineEcho',
        'FillingBlanksEcho',
        'SumEcho',
        'HotspotEcho',
        'TextDragEcho',
        'LigatureEcho',
        'ImgDragEcho',
        'SumEcho',
        'TextDragEcho2',
        'FillMatrix',
      ],
      questionTypes: [
        { label: "全部", "value": null },
        { label: "選擇題", value: 0},
        { label: "判斷題", value: 1},
        { label: "填空題", value: 2},
        { label: "算術題(定數)", value: 3},
        { label: "熱點圖", value: 4},
        { label: "文字拖拽", value: 5},
        { label: "連線題", value: 6},
        { label: "圖片拖拽題", value: 7},
        { label: "算術題(變數)", value: 8},
        { label: "文字拖拽(分類)", value: 9},
        { label: "矩陣填空", value: 10},
      ],
      form: {},
      
      questionList: [],
      previewSwitch: false
    }
  },
  methods: {
    // 预览
    preview() {
      this.previewSwitch = true
    },
    edit(id) {
      window.open(this.$router.resolve({path: `/question/${id}/edit`}).href, '_self');
      // this.$router.push({ path: `/question/${id}/edit` });
    },
    practiceDetail(id) {
      let path = `/practice/${id}`
      // this.$router.push({ path: `/practice/${id}` });
      this.resolveRouter(path)
    },
    getQuestionList() {
      let id = this.$route.params.id
      getPractises({question_id: id}).then((v)=>{
        // console.log(v)
        v.data.filter(its => {
          its.lang = its.lang == 0 ? '中文' : '英文'
        })
        this.questionList = v.data;
      })
    },
    getQuestionDetail() {
      let id = this.$route.params.id
      getQuestionDetail(id).then((v) => {
        this.echo = this.convertType[v.data.type]

        v.data.typeConvert = this.questionTypes[v.data.type + 1].label
        v.data.lang = v.data.lang == 0 ? '中文' : '英文'
        this.form = toSnakeCase(v.data);
        localStorage.setItem('testData', JSON.stringify(this.form))
        this.form.explanation = this.form.explanation.split('-----')[0]
        // console.log(JSON.stringify(this.form))
      });
    }
  },
  mounted() {
    this.getQuestionDetail()
    this.getQuestionList()
  }
};
</script>

<style lang="scss" scoped>
.question-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .back {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // cursor: pointer;
      .icon {
        width: 30px;
        height: 20px;
        position: relative;

        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          margin: auto;
          width: 10px;
          height: 10px;
          border: 2px solid #333;
          box-sizing: border-box;
          transform: rotateZ(45deg);
          border-top: none;
          border-right: none;
        }

        &:after {
          content: '';
          position: absolute;
          width: 20px;
          height: 2px;
          top: 0;
          left: 0;
          bottom: 0;
          margin: auto;
          background-color: #333;
        }
      }
      .text {
        font-weight: 480;
        color: #B62D2E;
        font-size: 25px;
      }
    }

    .func {
      display: flex;
      align-items: center;
    }
    .edit-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 128px;
      height: 44px;
      opacity: 1;
      cursor: pointer;
      border-radius: 50px;
      color: rgba(68, 68, 68, 1);
      background: rgba(248, 192, 59, 1);
      box-shadow: 0px 3px 6px  rgba(0, 0, 0, 0.16);
      margin-left: 20px;
    }
  }
  .container {
    flex: 1;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: flex-start;
    background-color: #fff;
    padding: 0 40px;
    box-sizing: border-box;

    .line {
      width: 100%;
    }

    & > .single {
      padding: 20px 0;
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: rgba(0, 0, 0, 1);

      span {
        margin-right: 10px;
      }
    }

    .question-cte {
      width: 100%;
      min-height: 400px;
      height: fit-content;
      font-family: 'TimesNewRoman', sans-serif;
    }

    .practice-list {
      width: 100%;
      .practice-single {
        width: 100%;
        border-bottom: 1px solid #ccc;
        padding: 15px 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;

        span {
          width: 30%;
          font-weight: 400;
          font-family: 'sans-serif';
          font-size: 12px;
        }
        .id{
          color: #0083f4;
          cursor: pointer;
        }
      }

      .th span {
        font-size: 20px;
        font-family: 'TaipeiSansTCBeta';
      }

      .empty-data {
        width: 100%;
        font-size: 18px;
        text-align: center;
        margin: 20px 0;
        font-family: sans-serif;
      }
    }
  }
}
</style>